<template>
	<div class="bg-gray-100 rounded-xl mt-6 shadow divide-y divide-gray-200">
		<form @submit.prevent="submit" class="">
			<div class="flex-grow md:grid grid-cols-6">
				<div class="pl-2 md:pl-6 pr-2 pt-4 py-2 md:py-4">
					<div :class="'text-gray-700 focus-within:text-orange-500'">
						<div class="flex justify-between flex-wrap">
							<label class="block font-medium">{{ __("Future") }}</label>
						</div>
						<div class="mt-1 relative">
							<ui-select
								v-model="pricingStrategy"
								:options="pricingStrategyOptions"
								:allow-empty="false"
							/>
						</div>
					</div>
				</div>
				<div class="px-2 py-2 md:py-4">
					<div :class="'text-gray-700 focus-within:text-orange-500'">
						<div class="flex justify-between flex-wrap">
							<label class="block font-medium">{{ __("Price Basis") }}</label>
						</div>
						<div class="mt-1 relative">
							<ui-validation-message :form="form" :field="'price'" />
							<span v-if="offer.price.type == 'FLAT'">
								<ui-input-group
									:no-label="true"
									:required="true"
									:form="form"
									:field="'price.mt'"
									v-model="offer.price.mt"
									class="-mt-1"
									:dp="2"
									suffix="€/t"
								/>
							</span>
							<span
								v-else-if="offer.price.type == 'INDEXED'"
								class="flex gap-x-2 items-center"
							>
								<ui-input-group
									:no-label="true"
									:required="true"
									:form="form"
									:field="'price.basis'"
									v-model="offer.price.basis"
									class="-mt-1"
									:dp="2"
									suffix="€/t"
								/>
							</span>
						</div>
					</div>
				</div>
				<div class="px-2 py-2 md:py-4 md:col-span-2">
					<div class="mt-4">
						<div class="flex justify-between flex-wrap">
							<div>80km</div>
							<div>250km</div>
						</div>
						<!--div v-if="offer.priceindication && offer.priceindication.enabled"-->
						<div>
							<ui-slider
								class="col-span-5 inline-edit-slider"
								v-model="offer.priceindication.distance_max"
								:max="250"
								:min="80"
							/>
							<!--ui-input-group :no-label="true" :required="true" :form="form"
                                v-on:input="checkMaxDistance"
                                :field="'priceindication.distance_max'" v-model="offer.priceindication.distance_max"
                                :maxValue="maxKm"
                                suffix="km" class="min-w-[3rem] max-w-[6rem] mt-6" /-->
						</div>
					</div>
				</div>
				<div class="px-2 py-2 pb-4 md:py-4">
					<div :class="'text-gray-700 focus-within:text-orange-500'">
						<div class="flex justify-between flex-wrap">
							<label class="block font-medium">{{ __("Validity") }}</label>
						</div>
						<div class="mt-1 relative">
							<ui-select
								v-model="offer.priceindication.valid_until_selection"
								:options="validityOptions"
								:allow-empty="false"
							/>
						</div>
					</div>
				</div>
				<div class="px-2 py-2 md:py-6">
					<div class="mt-3 md:mt-5 me-2 md:text-right">
						<ui-button v-on:click="submit()">{{ __("Save") }}</ui-button>
					</div>
				</div>
			</div>

			<div class="hidden md:block flex-grow md:grid grid-cols-6">
				<div class="pl-6 pr-2 pb-4"></div>
				<div class="px-2 pb-4"></div>
				<div class="px-2 pb-4 md:col-span-3">
					<div v-if="offer.price_indications_count">
<!--						<span class="font-semibold text-gray-500" v-if="locale == 'de'">-->
<!--							Bis zu {{ offer.price_indications_count }} Landwirte direkt-->
<!--							erreichen-->
<!--						</span>-->
<!--						<span class="font-semibold text-gray-500" v-else>-->
<!--							Reach up to {{ offer.price_indications_count }} farmers directly-->
<!--						</span>-->
					</div>
				</div>
				<div class="px-2 pb-4 text-right"></div>
			</div>
		</form>
	</div>
</template>

<script>
export default {
	props: {
		offer: {
			type: Object,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
		priceIndicationStat: {
			type: Array,
		},
		piEndOfDay: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			oldPriceIndicationStatus: this.offer.priceindication?.status,
			maxKm: 250,
		};
	},
	computed: {
		futuresOptions() {
			let tickers = {
					RAPE: "ECO",
					MAIZE: "EMA",
					FABA: null, // no futures available for FABA and PEA
					PEA: null,
				},
				desiredTicker = tickers[this.offer.product.type] || "EBM";
			return (this.activeFutures || [])
				.filter((f) =>
					this.form.product.type == "MAIZE"
						? f.ticker_code == desiredTicker || f.ticker_code == "EBM"
						: f.ticker_code == desiredTicker
				)
				.sort((a, b) =>
					a.ticker_code > b.ticker_code
						? 1
						: b.ticker_code > a.ticker_code
						? -1
						: 0
				);
		},
		pricingStrategyOptions() {
			let o = [{ id: "FLAT.", label: this.__("Flat Price") }],
				o2 = [];
			if (this.offer.trade == "BUY") {
				o2 = this.futuresOptions.map(function (f) {
					return {
						id: "INDEXED." + f.id,
						label: f.name,
					};
				});
			}
			return o.concat(o2);
		},
		validityOptions() {
			// no empty value allowed
			this.offer.priceindication.enabled = 1;
			let validityValues = [];
			let today = new Date();
			let currentDate = new Date(today);
			if (!this.piEndOfDay) {
				currentDate.setDate(currentDate.getDate() - 1);
			}
			if (this.offer.priceindication.valid_until_selection == null) {
				this.offer.priceindication.valid_until_selection = 1;
			}
			for (let i = 0; i < 3; i++) {
				currentDate.setDate(currentDate.getDate() + 1);
				while (currentDate.getDay() == 0 || currentDate.getDay() == 6) {
					currentDate.setDate(currentDate.getDate() + 1);
				}
				let dd = String(currentDate.getDate()).padStart(2, "0");
				let mm = String(currentDate.getMonth() + 1).padStart(2, "0");
				let yyyy = currentDate.getFullYear();
				validityValues.push({
					id: yyyy + "-" + mm + "-" + dd,
					label: dd + "." + mm + "." + yyyy,
				});
				if (
					this.offer.priceindication.valid_until ==
					yyyy + "-" + mm + "-" + dd + " 18:30:00"
				) {
					this.offer.priceindication.valid_until_selection =
						yyyy + "-" + mm + "-" + dd;
				}
			}
			return validityValues;
		},

		// a pricing strategy is either flat or indexed.<commodity future id>
		pricingStrategy: {
			get() {
				if (this.offer.price.type == "FLAT") {
					return "FLAT.";
				} else if (this.offer.price.type == "INDEXED") {
					return "INDEXED." + this.offer.price.commodity_future_id;
				} else {
					throw "unknown price type: " + this.offer.price.type;
				}
			},
			set(v) {
				let [priceType, commodityFutureId] = v.split(".");
				this.form.price.type = priceType;
				this.form.price.commodity_future_id =
					commodityFutureId == "" ? null : commodityFutureId;
			},
		},

		newPriceIndicationActive: {
			// after the input and has been saved and any batch processes run, will the PI be active for this offer?
			get() {
				console.log("COMPUTING NPI");
				if (this.offer._priceindication_active) {
					return true;
				} else {
					return false;
				}
			},
			set(v) {
				console.log("NPI", v);
				this.form._priceindication_active = v;
				if (
					this.form.priceindication.distance_max == null ||
					this.form.priceindication.distance_max == ""
				) {
					this.form.priceindication.distance_max = 150;
				}
			},
		},

		offerHasPriceIndication() {
			return this.offer.trade == "BUY" && this.offer.priceindication?.enabled;
		},
	},

	methods: {
		async submit() {
			let endpoint = this.$route("offers_buy.editInline", {
					id: this.offer.id,
				}),
				method = "patch",
				that = this;

			this.form.submit(method, endpoint, {
				preserveState: false,
				onSuccess(p) {
					console.log("form submit success");
				},
				onFinish(e) {
					console.log("form submit finished");
				},
				onError(e) {
					console.log("form submit error");
				},
			});
		},
	},
};
</script>
